const TRANSPORT_CONTENT_COLOR = '#707070';

export const getTransportLabelSx = (detailsMode = false) => ({
  fontSize: detailsMode ? '14px' : '18px',
  fontWeight: detailsMode ? 500 : 600,
});

export const getTransportContentSx = (detailsMode = false) => ({
  fontSize: detailsMode ? '14px' : '16px',
  fontWeight: 400,
  color: TRANSPORT_CONTENT_COLOR,
});

export const getTransportOptionLabelSx = (detailsMode = false) => ({
  m: 0,
  color: TRANSPORT_CONTENT_COLOR,
  '& .MuiFormControlLabel-label': {
    fontSize: detailsMode ? '14px' : '16px',
    fontWeight: 400,
  },
});

export const transportDetailsSectionSx = {
  '& > :not(.MuiDivider-root)': {
    padding: '16px 8px',
  },
};

// Shows disabled (read-only) controls in the same colors as editable ones so values stay easy to read
export const transportReadOnlySx = {
  '& .MuiInputBase-root.Mui-disabled': {
    color: 'text.primary',
    '& svg': { color: 'action.active' },
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: (theme) => theme.palette.text.primary,
  },
  // Autocomplete and date picker inputs (the theme's TextField border color)
  '& .MuiOutlinedInput-root.MuiInputBase-adornedEnd.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: '#637381',
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: 'text.secondary',
  },
  '& .MuiToggleButton-root.Mui-disabled': {
    color: 'action.active',
    '&.Mui-selected': { color: 'text.primary' },
  },
  '& .MuiCheckbox-root.Mui-disabled': {
    color: 'text.secondary',
    '&.Mui-checked': { color: 'primary.main' },
  },
  '& .MuiFormControlLabel-label.Mui-disabled': {
    color: 'inherit',
  },
  '& .MuiButton-root.Mui-disabled': {
    color: TRANSPORT_CONTENT_COLOR,
  },
};

export const transportDetailsRowSx = {
  display: 'flex',
  width: '100%',
};

export const transportFieldTitleSx = {
  fontSize: '14px',
  fontWeight: 600,
  color: TRANSPORT_CONTENT_COLOR,
};

export const transportFieldValueSx = {
  ml: '10px',
};
